import styled from 'styled-components'

interface TooltipArrowUiProps {
  left?: string
}

export const TooltipArrowUi = styled.div<TooltipArrowUiProps>`
  width: 16px;
  height: 6px;
  position: absolute;
  top: 100%;
  left: ${p => (p.left ? `${p.left}` : '50%')};
  transform: translateX(-50%);
  display: flex;
  overflow: hidden;
`
